import * as actionTypes from "../actionTypes";

export const initialState: {
  serviceCategory: number[];
  review: null | reviewType;
  checkoutError: boolean;
  addressBlacklisted: boolean;
  emailBlacklisted: boolean;
  timeError: boolean;
  authToken: string | null;
} = {
  serviceCategory: [],
  review: null,
  checkoutError: false,
  addressBlacklisted: false,
  emailBlacklisted: false,
  timeError: false,
  authToken: null
};

export type reviewType = {
  serviceId: number;
  service: string;
};

const reducer = (
  state = initialState,
  action: { type: string; payload?: any }
): typeof initialState => {
  switch (action.type) {
    case actionTypes.SET_SERVICE_CATEGORY: {
      return {
        ...state,
        serviceCategory: action.payload
      };
    }
    case actionTypes.SET_REVIEW: {
      return {
        ...state,
        review: { ...action.payload }
      };
    }
    case actionTypes.CLEAR_REVIEW: {
      return {
        ...state,
        review: null
      };
    }
    case actionTypes.SET_CHECKOUT_ERROR: {
      return {
        ...state,
        checkoutError: action.payload as boolean
      };
    }
    case actionTypes.SET_ADDRESS_BLACKLISTED: {
      return {
        ...state,
        addressBlacklisted: action.payload as boolean
      };
    }
    case actionTypes.SET_EMAIL_BLACKLISTED: {
      return {
        ...state,
        emailBlacklisted: action.payload as boolean
      };
    }
    case actionTypes.SET_TIME_ERROR: {
      return {
        ...state,
        timeError: action.payload as boolean
      };
    }
    case actionTypes.SET_AUTH_TOKEN: {
      return {
        ...state,
        authToken: action.payload
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
